import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const Layout = ({ children }) => {
  return (
    <div className="layout-container">
      <style>{`
        .layout-container {
          display: flex;
          height: 100vh;
          background-color: #f4f6f9;
        }
        .sidebar {
          width: 250px;
          background-color: #2c3e50;
          color: white;
          display: flex;
          flex-direction: column;
        }
        .sidebar-brand {
          font-size: 24px;
          font-weight: bold;
          padding: 20px;
          text-align: center;
          background-color: #1a252f;
          border-bottom: 1px solid #34495e;
        }
        .sidebar-menu {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .sidebar-menu li a {
          display: block;
          padding: 15px 20px;
          color: white;
          text-decoration: none;
          border-bottom: 1px solid #34495e;
          transition: 0.3s;
        }
        .sidebar-menu li a:hover {
          background-color: #25D366; /* WhatsApp Green */
        }
        .main-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
        }
        .header {
          height: 60px;
          background-color: white;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          display: flex;
          align-items: center;
          padding: 0 20px;
        }
        .page-content {
          padding: 20px;
          flex: 1;
        }
      `}</style>

      {/* Sidebar */}
      <div className="sidebar">
        <div className="sidebar-brand">WhatsApp API</div>
        <ul className="sidebar-menu">
          <li><Link to="/">📱 Devices</Link></li>
          <li><Link to="/bulk-send">✉️ Bulk Send Message</Link></li>
        </ul>
      </div>

      {/* Main Content Area */}
      <div className="main-content">
        <div className="header">
          <h5 className="m-0 text-muted">Admin Dashboard</h5>
        </div>
        
       <div className="page-content">
          <Outlet />  {/* <-- This injects your Devices page! */}
        </div>
      </div>
    </div>
  );
};

export default Layout;